import { MenuItem, Select, Typography } from '@mui/material'
import { MaybePromise } from '@reduxjs/toolkit/dist/query/tsHelpers'
import { FormEvent, useEffect, useRef, useState } from 'react'

import { getFinixConfig } from '../../../config/configs'

interface Props {
  formId: string
  submitCallback: (
    err: any,
    res: any,
    useLevelOneProcessing: boolean
  ) => MaybePromise<void>
}

interface FieldDefinition {
  idPrefix: string // the substring before "-field-wrapper"
  type: string
  placeholder: string
}

enum PaymentTypeOption {
  checking = 'CHECKING',
  savings = 'SAVINGS'
}

const FIELD_DEFINITIONS: FieldDefinition[] = [
  {
    idPrefix: 'name',
    type: 'name',
    placeholder: 'John Smith'
  },
  {
    idPrefix: 'account-number',
    type: 'account_number',
    placeholder: '000000000'
  },
  {
    idPrefix: 'bank-code',
    type: 'bank_code',
    placeholder: '123456789'
  }
]

export const PaymentFinixAchUI = ({ formId, submitCallback }: Props) => {
  const [paymentType, setPaymentType] = useState<PaymentTypeOption>(
    PaymentTypeOption.checking
  )

  const formSubmitRef = useRef<
    | ((
        env: string,
        appId: string,
        data: { account_type: string },
        callback: (err: any, res: any) => MaybePromise<void>
      ) => void)
    | null
  >(null)

  useEffect(() => {
    const form = window.PaymentForm.bankAccount(() => {})

    const initField: (def: FieldDefinition) => void = (def) => {
      const fieldInput = form.field(def.type, {
        validation: 'required',
        placeholder: { text: def.placeholder, hideOnFocus: true },
        styles: {
          default: {
            color: 'black'
          },
          success: {
            color: '#5cb85c'
          },
          error: {
            color: '#d9534f'
          }
        }
      })

      document
        .getElementById(`${def.idPrefix}-field-wrapper`)!
        .appendChild(fieldInput)
    }

    FIELD_DEFINITIONS.forEach((def) => initField(def))
    formSubmitRef.current = form.submitWithData.bind(form)
  }, [])

  const finixSubmitCallback = async function (err: any, res: any) {
    submitCallback(err, res, true)
  }

  const onSubmit: (event: FormEvent) => void = async (event) => {
    event.preventDefault()
    formSubmitRef.current &&
      formSubmitRef.current(
        getFinixConfig().finixEnvironment,
        getFinixConfig().applicationID,
        { account_type: paymentType },
        finixSubmitCallback
      )
  }

  return (
    <form id={formId} onSubmit={onSubmit}>
      <Typography>Name</Typography>
      <div className="fake-field">
        <div className="field-wrapper" id="name-field-wrapper"></div>
      </div>
      <Typography>Account Number</Typography>
      <div className="fake-field">
        <div className="field-wrapper" id="account-number-field-wrapper"></div>
      </div>
      <Typography>Bank Code</Typography>
      <div className="fake-field">
        <div className="field-wrapper" id="bank-code-field-wrapper"></div>
      </div>
      <Typography>Account Type</Typography>
      <Select
        value={paymentType}
        onChange={(event) =>
          setPaymentType(event.target.value as PaymentTypeOption)
        }>
        <MenuItem value={PaymentTypeOption.checking}>Checking</MenuItem>
        <MenuItem value={PaymentTypeOption.savings}>Savings</MenuItem>
      </Select>
    </form>
  )
}
